/* ROADSPARK design layer — spark engine, rails, reveal, scroll-to-buy.
   Self-contained; does not touch Shrine's external main.js contracts. */
(function () {
  'use strict';
  if (window.__rsLoaded) return; window.__rsLoaded = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ------------------------------------------------------------------ */
  /* Spark engine                                                        */
  /* ------------------------------------------------------------------ */
  function Sparks(canvas) {
    this.c = canvas;
    this.ctx = canvas.getContext('2d');
    this.p = [];
    this.mode = canvas.getAttribute('data-mode') || 'pulse'; // pulse | steady | hold | ambient
    this.dir = parseFloat(canvas.getAttribute('data-dir') || '-1');
    this.ox = parseFloat(canvas.getAttribute('data-ox') || '0.5');
    this.oy = parseFloat(canvas.getAttribute('data-oy') || '0.8');
    this.gy = parseFloat(canvas.getAttribute('data-gy') || '0');
    this.base = parseFloat(canvas.getAttribute('data-rate') || '160');
    this.originSel = canvas.getAttribute('data-origin');
    this.scope = canvas.closest('[data-rs-scope]') || canvas.parentElement;
    this.boost = 0; this.hold = false; this.t = 0; this.visible = false; this.running = false;
    this.acc = 0; this.last = 0;
    var self = this;
    this.resize();
    if ('ResizeObserver' in window) new ResizeObserver(function () { self.resize(); }).observe(canvas);
    else window.addEventListener('resize', function () { self.resize(); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (e) {
        self.visible = e[0].isIntersecting;
        if (self.visible) self.start();
      }, { rootMargin: '80px' }).observe(canvas);
    } else { this.visible = true; this.start(); }
    if (reduce) { this.prewarm(); }
  }
  Sparks.prototype.resize = function () {
    var r = this.c.getBoundingClientRect();
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    this.w = Math.max(1, r.width); this.h = Math.max(1, r.height);
    this.c.width = Math.round(this.w * dpr); this.c.height = Math.round(this.h * dpr);
    this.ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    this.scale = Math.max(.45, Math.min(1.5, this.w / 900));
  };
  Sparks.prototype.origin = function () {
    if (this.originSel) {
      var el = this.scope.querySelector(this.originSel);
      if (el) {
        var a = el.getBoundingClientRect(), b = this.c.getBoundingClientRect();
        if (a.width || a.height || a.left) {
          return { x: a.left + a.width / 2 - b.left, y: a.top + a.height / 2 - b.top };
        }
      }
    }
    return { x: this.ox * this.w, y: this.oy * this.h };
  };
  Sparks.prototype.rate = function () {
    var r = this.base;
    if (this.mode === 'pulse') {
      var ph = (this.t % 2.6) / 2.6;               // heel-drag rhythm
      r = ph < .55 ? this.base * (0.35 + 1.9 * Math.sin(ph / .55 * Math.PI)) : this.base * .06;
    } else if (this.mode === 'hold') {
      r = this.hold ? this.base * 2.4 : this.base * .05;
    } else if (this.mode === 'ambient') {
      r = this.base * (0.5 + 0.5 * Math.sin(this.t * 1.3));
    }
    return Math.max(0, r) * (this.w < 600 ? .7 : 1);
  };
  Sparks.prototype.spawn = function (o) {
    var s = this.scale;
    var spread = (Math.random() - .5) * 0.9;
    var ang = (this.dir < 0 ? Math.PI : 0) + this.dir * (-0.08 - Math.random() * 0.42) + spread * 0.35;
    var sp = (320 + Math.random() * 820) * s;
    var life = .45 + Math.random() * .95;
    this.p.push({
      x: o.x + (Math.random() - .5) * 10 * s, y: o.y + (Math.random() - .5) * 4 * s,
      px: o.x, py: o.y,
      vx: Math.cos(ang) * sp, vy: Math.sin(ang) * sp - Math.random() * 160 * s,
      life: life, max: life, w: (.8 + Math.random() * 1.9) * s, b: 0
    });
  };
  Sparks.prototype.step = function (dt) {
    this.t += dt;
    var o = this.origin();
    this.acc += this.rate() * dt;
    var n = Math.min(80, Math.floor(this.acc)); this.acc -= n;
    for (var i = 0; i < n; i++) this.spawn(o);
    var g = 1500 * this.scale, groundY = this.gy ? this.gy * this.h : o.y + 6 * this.scale;
    for (var j = this.p.length - 1; j >= 0; j--) {
      var q = this.p[j];
      q.px = q.x; q.py = q.y;
      q.vx *= (1 - 0.9 * dt); q.vy += g * dt;
      q.x += q.vx * dt; q.y += q.vy * dt;
      if (q.y > groundY && q.vy > 0 && q.b < 2) { q.y = groundY; q.vy *= -(.22 + Math.random() * .18); q.vx *= .6; q.b++; }
      q.life -= dt;
      if (q.life <= 0 || q.x < -40 || q.x > this.w + 40 || q.y > this.h + 40) this.p.splice(j, 1);
    }
    if (this.p.length > 1400) this.p.splice(0, this.p.length - 1400);
  };
  Sparks.prototype.color = function (k) { // k: 1 fresh → 0 dead
    if (k > .7) return [255, 246, 226];
    if (k > .45) return [255, 196, 90];
    if (k > .2) return [255, 118, 34];
    return [214, 60, 12];
  };
  Sparks.prototype.draw = function () {
    var ctx = this.ctx;
    ctx.clearRect(0, 0, this.w, this.h);
    ctx.globalCompositeOperation = 'lighter';
    ctx.lineCap = 'round';
    for (var i = 0; i < this.p.length; i++) {
      var q = this.p[i], k = q.life / q.max, c = this.color(k);
      ctx.strokeStyle = 'rgba(' + c[0] + ',' + c[1] + ',' + c[2] + ',' + (0.25 + 0.75 * k).toFixed(3) + ')';
      ctx.lineWidth = q.w * (0.5 + k);
      ctx.beginPath();
      ctx.moveTo(q.px - (q.x - q.px) * 1.6, q.py - (q.y - q.py) * 1.6);
      ctx.lineTo(q.x, q.y);
      ctx.stroke();
    }
    // contact glow
    var o = this.origin(), r = this.rate();
    if (r > 5) {
      var gl = Math.min(1, r / (this.base * 2));
      var rad = 70 * this.scale;
      var grd = ctx.createRadialGradient(o.x, o.y, 0, o.x, o.y, rad);
      grd.addColorStop(0, 'rgba(255,230,180,' + (0.55 * gl).toFixed(3) + ')');
      grd.addColorStop(.3, 'rgba(255,120,30,' + (0.35 * gl).toFixed(3) + ')');
      grd.addColorStop(1, 'rgba(255,80,10,0)');
      ctx.fillStyle = grd; ctx.beginPath(); ctx.arc(o.x, o.y, rad, 0, Math.PI * 2); ctx.fill();
    }
    ctx.globalCompositeOperation = 'source-over';
  };
  Sparks.prototype.prewarm = function () {
    this.resize();
    for (var i = 0; i < 70; i++) this.step(1 / 60);
    this.draw();
  };
  Sparks.prototype.start = function () {
    if (this.running || reduce) return;
    this.running = true;
    var self = this; self.last = performance.now();
    function loop(now) {
      if (!self.visible) { self.running = false; return; }
      var dt = Math.min(.05, (now - self.last) / 1000); self.last = now;
      self.step(dt); self.draw();
      if (self.onframe) self.onframe(self);
      requestAnimationFrame(loop);
    }
    requestAnimationFrame(loop);
  };

  function initSparks(root) {
    (root || document).querySelectorAll('canvas[data-rs-sparks]').forEach(function (c) {
      if (c.__rs) return; c.__rs = new Sparks(c);
    });
  }

  /* ------------------------------------------------------------------ */
  /* Spark Lab (hold to drag)                                            */
  /* ------------------------------------------------------------------ */
  function initLab(root) {
    (root || document).querySelectorAll('[data-rs-lab]').forEach(function (lab) {
      if (lab.__rs) return; lab.__rs = true;
      var canvas = lab.querySelector('canvas[data-rs-sparks]');
      if (!canvas) return;
      initSparks(lab);
      var sp = canvas.__rs, stage = lab.querySelector('.rs-lab__stage');
      var bars = lab.querySelectorAll('.rs-lab__meter i');
      var label = lab.querySelector('[data-rs-state]');
      function set(on) {
        sp.hold = on; lab.classList.toggle('is-holding', on);
        if (label) label.textContent = on ? (label.getAttribute('data-on') || 'Sparking') : (label.getAttribute('data-off') || 'Idle');
      }
      if (reduce) { sp.hold = true; sp.prewarm(); }
      var targets = [stage];
      targets.forEach(function (t) {
        t.addEventListener('pointerdown', function (e) { e.preventDefault(); set(true); try { t.setPointerCapture(e.pointerId); } catch (x) {} });
        t.addEventListener('pointerup', function () { set(false); });
        t.addEventListener('pointercancel', function () { set(false); });
        t.addEventListener('pointerleave', function () { set(false); });
      });
      stage.addEventListener('keydown', function (e) { if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); set(true); } });
      stage.addEventListener('keyup', function (e) { if (e.key === ' ' || e.key === 'Enter') set(false); });
      sp.onframe = function (s) {
        var lvl = Math.min(bars.length, Math.round(s.p.length / 55));
        for (var i = 0; i < bars.length; i++) bars[i].classList.toggle('on', i < lvl);
      };
    });
  }

  /* ------------------------------------------------------------------ */
  /* Rails (swipe + arrows, wrap-around continuous)                      */
  /* ------------------------------------------------------------------ */
  function initRails(root) {
    (root || document).querySelectorAll('[data-rs-rail]').forEach(function (rail) {
      if (rail.__rs) return; rail.__rs = true;
      var track = rail.querySelector('.rs-rail__track');
      var prev = rail.querySelector('[data-rs-prev]'), next = rail.querySelector('[data-rs-next]');
      var count = rail.querySelector('.rs-rail__count');
      if (!track) return;
      function stepW() {
        var first = track.children[0];
        if (!first) return track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
        return first.getBoundingClientRect().width + gap;
      }
      function atEnd() { return track.scrollLeft + track.clientWidth >= track.scrollWidth - 4; }
      function go(d) {
        if (d > 0 && atEnd()) { track.scrollTo({ left: 0, behavior: 'smooth' }); return; }
        if (d < 0 && track.scrollLeft <= 4) { track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' }); return; }
        track.scrollBy({ left: d * stepW(), behavior: 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { go(-1); });
      if (next) next.addEventListener('click', function () { go(1); });
      function upd() {
        if (!count) return;
        var i = Math.round(track.scrollLeft / Math.max(1, stepW())) + 1;
        count.textContent = String(Math.min(i, track.children.length)).padStart(2, '0') + ' / ' + String(track.children.length).padStart(2, '0');
      }
      track.addEventListener('scroll', function () { window.requestAnimationFrame(upd); }, { passive: true });
      upd();
    });
  }

  /* ------------------------------------------------------------------ */
  /* Scroll to buy box                                                   */
  /* ------------------------------------------------------------------ */
  function initBuy(root) {
    (root || document).querySelectorAll('[data-rs-buy]').forEach(function (a) {
      if (a.__rs) return; a.__rs = true;
      a.addEventListener('click', function (e) {
        var t = document.querySelector('[id^="ProductInfo-"]') || document.getElementById('rs-buy');
        if (t) {
          e.preventDefault();
          var y = t.getBoundingClientRect().top + window.pageYOffset - 90;
          window.scrollTo({ top: Math.max(0, y), behavior: reduce ? 'auto' : 'smooth' });
        }
      });
    });
  }

  /* ------------------------------------------------------------------ */
  /* Reveal                                                              */
  /* ------------------------------------------------------------------ */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.rs-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window) || reduce) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  function init(root) { initSparks(root); initLab(root); initRails(root); initBuy(root); initReveal(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  window.RoadSpark = { init: init };
})();
